/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { DelCustomerShortVO } from "./del-customer-short-vo.model";

export class DelCustomerVO extends DelCustomerShortVO {

  mainEmailAddress: string | undefined = undefined;
  mainPhoneNumber: string | undefined = undefined;
  hasContacts: boolean | undefined = undefined; //frontend only
  local: boolean | undefined = undefined;
  country: string | undefined = undefined;
  isBlocked = false;
}
